import * as Styled from "./styled";
import logo from "./assets/imversed-logo.svg";

import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { disconnect, fetchAccount, fetchBalance } from "../../reducers/wallet";
import WalletStatus from "../../reducers/wallet/walletStatus";

import { Avatar } from "@mui/material";
import { useTheme } from "styled-components";

import imversed from "./assets/ic-about-imversed.svg";
import discord from "./assets/ic-discord.svg";
import twitter from "./assets/ic-twitter.svg";
import arrowDown from "./assets/ic-arrow-down.svg";
import arrowUp from "./assets/ic-arrow-up.svg";
import copy from "./assets/ic-copy.svg";
import logout from "./assets/ic-logout.svg";

function Header(props) {
  const theme = useTheme();

  const [exploreAnchorEl, setExploreAnchorEl] = useState(null);

  const accountAnchorRef = useRef(null);
  const [accountAnchorEl, setAccountAnchorEl] = useState(null);

  const walletConnected = useSelector((state) => state.wallet.status === WalletStatus.connected);
  const walletAddress = useSelector((state) => state.wallet.account.address);
  const walletBalance = useSelector((state) => state.wallet.account.balance);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!walletConnected) return;

    if (walletAddress) {
      dispatch(fetchBalance());
    } else {
      dispatch(fetchAccount());
    }
  }, [dispatch, walletConnected, walletAddress]);

  const handleExploreMenuClose = () => {
    setExploreAnchorEl(null);
  };

  const handleExploreMenuClick = (event) => {
    setExploreAnchorEl(event.currentTarget);
  };

  const openInNewTab = (url) => {
    setExploreAnchorEl(null);
    window.open(url, "_blank", "noopener,noreferrer");
  };

  const handleCopyAddress = () => {
    if (navigator.clipboard) {
      navigator.clipboard.writeText(walletAddress);
    } else if (window.clipboardData) {
      window.clipboardData.setData("Text", walletAddress);
    }
  };

  const handleLogoutAccount = () => {
    dispatch(disconnect());
    handleCloseAccountMenu();
  };

  const handleOpenAccountMenu = () => {
    dispatch(fetchBalance());
    setAccountAnchorEl(accountAnchorRef.current);
  };

  const handleCloseAccountMenu = () => {
    setAccountAnchorEl(null);
  };

  const explorePopoverMenu = () => {
    return (
      <>
        <Styled.PopoverMenu
          keepMounted
          anchorEl={exploreAnchorEl}
          onClose={handleExploreMenuClose}
          open={Boolean(exploreAnchorEl)}
        >
          <Styled.ExploreMenuItem onClick={() => openInNewTab("https://imversed.com/")}>
            <Styled.ImageButton $image={imversed} onClick={() => openInNewTab("https://imversed.com/")} />
            About Imversed
          </Styled.ExploreMenuItem>
          <Styled.Spacer />

          <Styled.ExploreMenuItem onClick={() => openInNewTab("https://discord.com/invite/3f79ygxZ3y")}>
            <Styled.ImageButton $background="#7289DA" $image={discord} />
            Join our Discord
          </Styled.ExploreMenuItem>
          <Styled.Spacer />

          <Styled.ExploreMenuItem onClick={() => openInNewTab("https://twitter.com/")}>
            <Styled.ImageButton $background="#55ACE3" $image={twitter} />
            Twitter
          </Styled.ExploreMenuItem>
        </Styled.PopoverMenu>
      </>
    );
  };

  const accountPopoverMenu = () => {
    return (
      <Styled.PopoverMenu
        keepMounted
        anchorEl={accountAnchorEl}
        onClose={handleCloseAccountMenu}
        open={Boolean(accountAnchorEl)}
      >
        <Styled.AccountMenuItem style={{ pointerEvents: "none" }}>
          <span style={{ fontWeight: "600", fontSize: "14px", paddingRight: "8px" }}>Balance:</span>
          <span style={{ fontWeight: "400", fontSize: "14px" }}>{walletBalance} Eth</span>
        </Styled.AccountMenuItem>

        <Styled.Spacer marginLeft={16} />

        <Styled.AccountMenuItem style={{ color: theme.color.text.destructive }} onClick={() => handleLogoutAccount()}>
          <Styled.ImageButton $image={logout} />
          Log out
        </Styled.AccountMenuItem>
      </Styled.PopoverMenu>
    );
  };

  return (
    <Styled.Container>
      <Styled.Logo src={logo} onClick={() => openInNewTab("https://imversed.com/")} />
      <Styled.ButtonsContainer>
        <Styled.ExploreMenuButton
          aria-controls="simple-menu"
          aria-haspopup="true"
          style={{
            color: exploreAnchorEl ? theme.color.accent : theme.color.text.primary,
          }}
          endIcon={
            exploreAnchorEl ? (
              <Avatar src={arrowUp} sx={{ height: "6px", width: "12px" }} />
            ) : (
              <Avatar src={arrowDown} sx={{ height: "6px", width: "12px" }} />
            )
          }
          onClick={handleExploreMenuClick}
        >
          Explore
        </Styled.ExploreMenuButton>

        {explorePopoverMenu()}

        {walletAddress ? (
          <>
            <Styled.AccountButtonContainer ref={accountAnchorRef} aria-controls="simple-menu" aria-haspopup="true">
              <Styled.AccountAddressButton
                onClick={() => {
                  handleOpenAccountMenu();
                }}
              >
                {walletAddress}
              </Styled.AccountAddressButton>
              <Styled.AccountCopyButton
                src={copy}
                onClick={() => {
                  handleCopyAddress();
                }}
              ></Styled.AccountCopyButton>
            </Styled.AccountButtonContainer>

            {accountPopoverMenu()}
          </>
        ) : (
          <Styled.BackgroundButton onClick={() => props.onDisplayPopupWallet(true)}>
            Connect Wallet
          </Styled.BackgroundButton>
        )}
      </Styled.ButtonsContainer>
    </Styled.Container>
  );
}

export default Header;
